// Configuración de entorno para Olimpo Web
// Detecta automáticamente si estamos en desarrollo local o producción

const getEnvironment = () => {
  // 1. Verificar si estamos en producción
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }

  // 2. Por defecto, asumir development
  return 'development';
};

const getApiBaseUrl = () => {
  const environment = getEnvironment();
  
  switch (environment) {
    case 'development':
      return 'http://localhost:8080';
    case 'production':
      // En producción, usar el dominio de la API configurado en variables de entorno
      // o por defecto usar api.olimpo.club
      const productionDomain = process.env.REACT_APP_API_DOMAIN || 'https://api.olimpo.club';
      return productionDomain;
    default:
      return 'http://localhost:8080';
  }
};

const getFrontendUrl = () => {
  const environment = getEnvironment();
  
  switch (environment) {
    case 'development':
      return 'http://localhost:3000';
    case 'production':
      return window.location.origin;
    default:
      return 'http://localhost:3000';
  }
};

const getGoogleRedirectUrl = () => {
  const frontendUrl = getFrontendUrl();
  return `${frontendUrl}/auth/callback`;
};

// Configuración exportada
export const environment = getEnvironment();
export const API_BASE_URL = getApiBaseUrl();
export const FRONTEND_URL = getFrontendUrl();
export const GOOGLE_REDIRECT_URL = getGoogleRedirectUrl();

// Configuración de Google OAuth
export const GOOGLE_OAUTH_CONFIG = {
  clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  redirectUri: getGoogleRedirectUrl(),
  scope: 'openid email profile',
  responseType: 'code'
};

// Log de configuración para debugging
console.log('Configuración de entorno:', {
  environment,
  API_BASE_URL,
  FRONTEND_URL,
  GOOGLE_REDIRECT_URL,
  NODE_ENV: process.env.NODE_ENV,
  hostname: window.location.hostname,
  port: window.location.port
});

const config = {
  environment,
  API_BASE_URL,
  FRONTEND_URL,
  GOOGLE_REDIRECT_URL,
  GOOGLE_OAUTH_CONFIG
};

export default config;
